import useMap from "../utils/useMap";



const useQueueQuery = () => {
    const queue = useMap();

    const delay = (time) => new Promise(next => setTimeout(next, time));

    const setQueue = (key, fn) => {
        const list = queue.get(key) || [];
        list.push(fn);
        queue.set(key, list);
    }

    const runQueue = (key) => {
        if (!queue.has(key)) return;
        delay(50).then(() => {
            const list = queue.get(key);
            while (list.length > 0) {
                const fn = list.shift();
                fn.call(null);
            }
        })
    }

    return {
        setQueue,
        runQueue
    }
}

const useSharing = (() => {


    const caching = useMap();
    const
        queueQueryMethod = useQueueQuery(),
        queueQueryProp = useQueueQuery();

    const transformToQueryResult = (prop) => {
        return {
            value: prop
        }
    }

    return () => {

        const useSetSharing = (uniqueKey) => {
            if (caching.has(uniqueKey)) {
                return caching.get(uniqueKey).export;
            }

            const sharedProps = {},
                sharedMethods = {};

            const proxy = new Proxy(sharedProps, {
                set(target, k, value) {
                    const prop = target[k];
                    return Reflect.set(prop, k, value);
                },
                get(target, k) {
                    return target[k][k];
                }
            })

            const shareProp = (prop) => {
                for (let k in prop) {
                    sharedProps[k] = prop;
                }
            }

            const shareMethod = (method) => {
                Object.assign(sharedMethods, method);
            }

            const rs = {
                shareMethod,
                shareProp,
            }

            caching.set(uniqueKey, {
                props: {},
                method: sharedMethods,
                export: rs,
                proxy
            })

            queueQueryProp.runQueue(uniqueKey);
            queueQueryMethod.runQueue(uniqueKey);
            return rs;
        }

        const queryProp = (key) => new Promise(next => {
            if (caching.get(key)) {
                next(transformToQueryResult(caching.get(key).proxy))
            } else {
                queueQueryProp.setQueue(key, () => {
                    next(transformToQueryResult(caching.get(key).proxy))
                });
            }
        })


        const queryMethod = (key) => new Promise(next => {
            if (caching.get(key)) {
                next(caching.get(key).method)
            } else {
                queueQueryMethod.setQueue(key, () => {
                    next(caching.get(key).method)
                });
            }
        })

        return {
            queryProp,
            queryMethod,
            useSetSharing
        };
    }
})();

export default useSharing;